import React from 'react'
import EditRecipeForm from './EditRecipeForm'

const EditRecipe = (props) => {

    return (
         <div>
             <EditRecipeForm />
         </div>
    )
}

export default EditRecipe